
<script>

import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import CrmOrgForm from './crm-org-form'
import CrmOrgNovoForm from './crm-org-novo-form'
import CrmFiltrosNegocio from './crm-filtros-negocio'
import { apiDownloadPDF, apiEmailPDF } from '../shared/api-functions'
import { getText, formatDate, formatDataHoraExtenso } from '../shared/utils'
import { SysVars } from '../main';

export default {
    data () {
        return {
            showFormNovo: false,
            filter: '',
            textQuery: '',
            statusQuery: '',
            metadata: this.$store.getters.getEntities.metadata,
            selectedFiltro: null,
            selectedUsuario: null,
            selectedEquipe: null,

            codorg: null,
        }
    },

    components: {
        BarList, BarGrid, CrmOrgNovoForm, CrmOrgForm, CrmFiltrosNegocio
    },

    computed: {
        organizacaoList: function () {
            return this.$store.getters.getOrganizacaoList
        },
    },

    watch: {

    },

    filters: {

    },

    methods: {
        formatDate (value) {
            return formatDataHoraExtenso(value, true)
        },
        handleStyle(color) {
            if (color)
              return 'color: white; background-color: ' + color;
            else 
              return ''
        },
        handleStyleAgenda(obj) {
            if (obj.dias_atividade > 0)
              return 'color: red;';
            else 
            if (obj.dias_atividade < 0)
              return 'color: green;'
            else  
              return ''
        },
        handleChangeUsuario (cod) {
            this.selectedUsuario = cod
            this.loadData()
        },
        handleChangeFiltroOrg (cod) {
            this.selectedFiltro = cod
            this.loadData()
        },
        handleChangeEquipe (cod) {
            this.selectedEquipe = cod
            this.loadData()
        },
        handleEdit (codorg) {
            this.codorg = codorg
            this.$modalForm(true)
            // this.$router.push('/crm/organizacao/' + codorg)
        },
        handleAction (act, codorg) {
            if (act == 1) {
                //print
                //apiDownloadPDF(this, 'print/sales/' + codorg)
            } 
        },
        handleNovo () {
            //abre a tela de edicao
            this.codorg = null;
            this.$modalForm(true)
            this.showFormNovo = true; //exibe o form de manutencao
        },
        closeForm() {
            this.showFormNovo = false
            this.codorg = null
            this.$modalForm(false)
            // this.$scrollTo(0)
            this.loadData()
        },
        textSearch(value) {
            //efetua a pesquisa por texto
            this.textQuery = 'text=' + value
            this.loadData()
        },
        textAtividade (count) {
            if (count == 1)
                return '1 Atividade Atrasada'
            else if (count > 1)
                return count + ' Atividades Atrasadas'
            else
                return ''
        },
        loadData() {
            let query = ''
            if (!this.selectedFiltro || this.selectedFiltro === 0) {
                query = ''
            } else {
                query = 'filtro=' + this.selectedFiltro
            }

            if (this.selectedUsuario) {
              if (query)
                query = query + '&'
              query = query + 'codusuario=' + this.selectedUsuario
            }

            if (this.selectedEquipe) {
              if (query)
                query = query + '&'
              query = query + 'codequipe=' + this.selectedEquipe
            }

            let param = {}
            param.query = ''
            if (query) {
                param.query = query
                if (this.textQuery) {
                     param.query = param.query + '&'
                }
            }
            if (this.textQuery) {
                param.query = param.query + this.textQuery
            } else {
                param.filter = this.filter
            }
            this.$store.dispatch('loadOrganizacao', param)
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },
    },

    created () {
        this.$store.dispatch('loadConfigCrm', this).then(
            this.loadData()
        )

        // let filters = [
        //     { label: 'Todos os Contatos', qt: null, status: null },
        //     { label: 'Contatos com negócio em aberto', qt: null, status: 'comnegocio' },
        //     { label: 'Contatos com atividade pendente', qt: null, status: 'comagenda' },
        // ]
        // this.paramFilterList = { total: filters, selectedStatus: '' }
        
    }

}

</script>

<template>
    <div>
        <div id="list"> 

            <bar-list
                :refresh-button="true" 
                :new-button="true" 
                :pdf-button="false"
                :xls-button="true"
                single-entity="Organização" 
                plural-entity="Organizações"
                @search="textSearch"
                @new="handleNovo"
                @refresh="loadData">
            </bar-list>

            <div class="mt-2">
                <crm-filtros-negocio :organizacao="true" @changeUsuario="handleChangeUsuario" @changeEquipe="handleChangeEquipe" @changeFiltroOrg="handleChangeFiltroOrg"></crm-filtros-negocio>
            </div>  

            <div class="default-container py-0">
                <div v-if="organizacaoList.length == 0" class="no-content mb-4">Nenhuma organização foi encontrada</div>
                <div class="mainbox" v-for="(organizacao, index) in organizacaoList" :key="index">
                    <div class="row p-2" @click="handleEdit(organizacao.codorg)">
                        <div class="col-auto text-center">
                            <div class="list-icon">
                                <i class="fa fa-university" aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="col-md-6 col-12">
                            <span class="list-title">{{ organizacao.nome }}</span>
                            <span v-if="organizacao.excluido=='S'" class="badge badge-red ml-2">Excluído</span>
                            <div class="w-100"></div>
                            <span class="lbl-list-detalhe"><i class="fa fa-calendar pr-2" aria-hidden="true"></i> {{ organizacao.data | formatDataHoraExtenso }}</span>
                            <span class="lbl-list-detalhe"><i class="fa fa-user-circle pr-2" aria-hidden="true"></i> {{ organizacao.nome_usuario }}</span>
                            <div class="w-100 mt-3"></div>
                            <div v-if="organizacao.pessoas.length > 0">
                                <a class="data-list pr-2" :href="'#/crm/pessoa/'+pessoa.codpessoa" v-for="(pessoa, index2) in organizacao.pessoas" :key="index2"><i class="fa fa-user pr-2" aria-hidden="true"></i> {{ pessoa.nome }}</a>
                            </div>
                            <div class="w-100 mt-3"></div>
                            <div v-if="organizacao.count_abertos || organizacao.count_negocios">
                                <label class="lbl-list">Negócios Abertos <span class="lbl-list">{{ organizacao.count_abertos }}</span></label>
                                <label class="lbl-list">Negócios Fechados <span class="lbl-list">{{ organizacao.count_negocios }}</span></label>
                            </div>
                        </div>
                        <div class="col-md-2 col-4">
                            <span v-if="organizacao.tag.length>0" class="tag-input-color mr-3" :style="handleStyle(organizacao.tag[0].cor)">{{ organizacao.tag[0].descricao }} </span>
                        </div>
                        <div class="col-md-2 col-4">
                            <span class="icon icon-atrasado" v-if="organizacao.dias_atividade>0" :title="'Atividade atrasada há ' + organizacao.dias_atividade + ' dias'" data-toggle="tooltip" data-placement="top"><i class="fa fa-calendar" aria-hidden="true"></i></span>
                            <span class="icon icon-sem-agenda" v-if="organizacao.count_agenda == 0" data-toggle="tooltip" data-placement="top" title="Nenhuma atividade"><i class="fa fa-warning" aria-hidden="true"></i></span>
                            <span class="icon icon-agenda" v-if="organizacao.count_agenda > 0 && organizacao.dias_atividade <= 0" data-toggle="tooltip" data-placement="top" title="Atividade planejada"><i class="fa fa-calendar" aria-hidden="true"></i></span>
                            <label class="lbl-list icon-sem-agenda" v-if="!organizacao.proxima_atividade">Sem Atividade</label>
                            <span class="data-list" :style="handleStyleAgenda(organizacao)"> {{ formatDate(organizacao.proxima_atividade) }} </span>
                        </div>
                        <div class="col-auto ml-auto">
                                    <bar-grid 
                                        :options="{barDefault: true, btnEdit: true}"
                                        :moreActions="[]"
                                        @edit="handleEdit(organizacao.codorg)"
                                        @action="handleAction(id, organizacao.codorg)">
                                    </bar-grid>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <crm-org-novo-form v-if="showFormNovo" :index="this.codorg" @closeform="closeForm"></crm-org-novo-form>

        <div class="deal-form-side" v-if="codorg">
            <crm-org-form :index="codorg" @closeform="closeForm"></crm-org-form>
        </div>
    </div>
</template>


<style>

.list-title {
    display: inline-block;
    max-width: 100%;
    /* font-size: 16px; */
    font-weight: 700;
    color: #4993d2;
}

</style>



// WEBPACK FOOTER //
// src/forms-crm/crm-org-list.vue